/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StatusCategory from './StatusCategory';

/**
 * The CreateJobStatusRequest model module.
 * @module model/CreateJobStatusRequest
 * @version V1
 */
class CreateJobStatusRequest {
    /**
     * Constructs a new <code>CreateJobStatusRequest</code>.
     * @alias module:model/CreateJobStatusRequest
     * @param statusCategoryID {module:model/StatusCategory} 
     * @param name {String} 
     */
    constructor(statusCategoryID, name) { 
        
        CreateJobStatusRequest.initialize(this, statusCategoryID, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, statusCategoryID, name) { 
        obj['statusCategoryID'] = statusCategoryID;
        obj['name'] = name;
    }

    /**
     * Constructs a <code>CreateJobStatusRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateJobStatusRequest} obj Optional instance to populate.
     * @return {module:model/CreateJobStatusRequest} The populated <code>CreateJobStatusRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateJobStatusRequest();

            if (data.hasOwnProperty('statusCategoryID')) {
                obj['statusCategoryID'] = StatusCategory.constructFromObject(data['statusCategoryID']);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CreateJobStatusRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateJobStatusRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CreateJobStatusRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}

CreateJobStatusRequest.RequiredProperties = ["statusCategoryID", "name"];

/**
 * @member {module:model/StatusCategory} statusCategoryID
 */
CreateJobStatusRequest.prototype['statusCategoryID'] = undefined;

/**
 * @member {String} name
 */
CreateJobStatusRequest.prototype['name'] = undefined;






export default CreateJobStatusRequest;

